(() => {
  if (window.kmCustomizerPaste) return;
  window.kmCustomizerPaste = true;
  async function importImages(panel, blobs) {
    const input = panel.querySelector('[data-customizer-upload]');
    if (!input || input.disabled || !blobs.length) return;
    const transfer = new DataTransfer();
    for (const blob of blobs) {
      let image = blob;
      if (!/^image\/(png|jpeg)$/.test(blob.type)) {
        const bitmap = await createImageBitmap(blob);
        const canvas = document.createElement('canvas');
        canvas.width = bitmap.width;
        canvas.height = bitmap.height;
        canvas.getContext('2d').drawImage(bitmap, 0, 0);
        bitmap.close();
        image = await new Promise(resolve => canvas.toBlob(resolve, 'image/png'));
        if (!image) throw new Error('Unable to read this clipboard image.');
      }
      transfer.items.add(new File([image], image.type === 'image/jpeg' ? 'clipboard.jpg' : 'clipboard.png', { type: image.type }));
    }
    if (panel.hidden) panel.closest('[data-customizer]')?.querySelector('[data-customizer-method="upload"]')?.click();
    input.files = transfer.files;
    input.dispatchEvent(new Event('change', { bubbles: true }));
    const status = panel.querySelector('[role="status"]');
    if (status) { status.hidden = false; status.textContent = 'Clipboard image added.'; }
  }
  document.addEventListener('paste', event => {
    if (event.defaultPrevented || event.target.closest?.('input:not([type="file"]), textarea, [contenteditable="true"]')) return;
    const panel = [...document.querySelectorAll('[data-customizer-panel="upload"]')].find(p => !p.hidden && p.getClientRects().length)
      || document.querySelector('[data-customizer-panel="upload"]');
    if (!panel) return;
    const files = [...(event.clipboardData?.items || [])].filter(item => item.kind === 'file' && item.type.startsWith('image/')).map(item => item.getAsFile()).filter(Boolean);
    if (!files.length) return;
    event.preventDefault();
    importImages(panel, files).catch(error => {
      const status = panel.querySelector('[role="status"]');
      if (status) { status.hidden = false; status.textContent = error.message; }
    });
  });
})();
